import React, { useMemo } from "react";
import { useEffect, useState, useRef } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { InputTextarea } from "primereact/inputtextarea";
import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/mantine";
import { defaultBlockSpecs, BlockNoteSchema } from "@blocknote/core";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
interface ProposalComparisonProps {
  onChange: (markdown: string) => void;
}
export default function ProposalComparison(props: any, { onChange }: ProposalComparisonProps) {
  const [isProposalComparisonTextEditing, setIsProposalComparisonTextEditing] = useState(false);
  const [isComparisonDetailsEditing, setIsComparisonDetailsEditing] = useState(false);
  const [comparisonData, setComparisonData] = useState<any>("");
  const filteredBlockSpecs = useMemo(() => {
      const { image, video, file, audio, ...rest } = defaultBlockSpecs;
      return rest;
    }, []);
    const schema = useMemo(
      () =>
        BlockNoteSchema.create({
          blockSpecs: filteredBlockSpecs,
        }),
      [filteredBlockSpecs]
    );
    const editor = useCreateBlockNote({ schema });

  useEffect(() => {
    if (props.ourProposal) {
      setComparisonData(props.ourProposal || {});
    }
  }, [props.ourProposal]);
  useEffect(() => {
    const loadInitialHTML = async () => {
      if (!editor || !props.ourProposal) return;
      const compare = props.ourProposal?.replace(/^"|"$/g, "").replace(/\\n/g, "\n") ?? "";
      setComparisonData(compare);

      try {
        const markdown = `${compare}`;
        const blocks = await editor?.tryParseMarkdownToBlocks?.(markdown);

        if (Array.isArray(blocks) && blocks.length > 0) {
          await editor.replaceBlocks(editor.document, blocks);
        } else {
          console.warn("No valid blocks returned from tryParseMarkdownToBlocks");
        }
      } catch (err) {
        console.error("Error parsing markdown to blocks or replacing blocks:", err);
      }
    };

    if (isComparisonDetailsEditing) {
      loadInitialHTML();
    }
  }, [isComparisonDetailsEditing, editor, props.ourProposal]);

  const onComparisonDetailsChange = async () => {
    const markdown = await editor.blocksToMarkdownLossy(editor.document);
    if (onChange) {
      onChange(markdown);
    }
    setComparisonData(markdown);
  };
  return (
    <div className="container p-0  border" >
      <section className="section-proposalcomparison">
        <div className="row  px-3 ">
          <div className="col-12 ">
            <span className="h3 pt-2" style={{ borderTop: `2px solid ${props.secondaryColor}`, color: props.primaryColor }}>
              Proposal Comparison{" "}
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isProposalComparisonTextEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsProposalComparisonTextEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isProposalComparisonTextEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          onClick={() => {
                            setIsProposalComparisonTextEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                          title="Save"
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsProposalComparisonTextEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            {isProposalComparisonTextEditing ? (
              <InputTextarea
                value={props.proposalComparisonDescription}
                onChange={props.onProposalComparisonDescriptionChange}
                autoResize
                className="text-12 w-100 mt-1"
              />
            ) : (
              <p className="small mb-1 mt-2">{props.proposalComparisonDescription}</p>
            )}
          </div>
          <div className="col-12 mb-2">
            {!isComparisonDetailsEditing ? (
              <>
                {props.isEditable && !props.isGeneratingPdf ?
                  <>
                    <i
                      className="fa fa-pencil text-12 ms-2 mb-2 show-cursor d-flex flex-row justify-content-end"
                      title="Edit"
                      onClick={() => setIsComparisonDetailsEditing(true)}
                    />
                  </>
                  :
                  null}
                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} className="markdown-table quote-proposal-table mt-3">
                  {comparisonData.replace(/^"|"$/g, "").replace(/\\n/g, "\n")}
                </ReactMarkdown>
              </>
            ) : (
              <>
                <span className="text-12 mb-2 d-flex flex-row justify-content-end ">
                  {isComparisonDetailsEditing && props.saveLoading ? (
                    <div className="d-inline-flex align-items-center">
                      <AtkLoader />
                    </div>
                  ) : (
                    <i
                      className="fa fa-check mx-2 show-cursor text-success "
                      onClick={() => {
                        setIsComparisonDetailsEditing(false);
                        props.onTemplateDetailsSave(null, null, null, null, comparisonData);
                      }}
                      title="Save"
                    />
                  )}
                  <i
                    className="fa fa-times show-cursor text-danger"
                    title="Cancel"
                    onClick={() => {
                      setIsComparisonDetailsEditing(false);
                      props.onCancelTemplateDetailsToSave();
                    }}
                  />
                </span>
                <div className="markdown-table ">
                  <BlockNoteView
                    editor={editor}
                    onChange={onComparisonDetailsChange}

                  // editable={true}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
